'use client'
import React, {useEffect, useState} from 'react'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import useTranslation from '../util/translations/useTranslation'
import Link from 'next/link'
import {ROUTE_LANG_PRIVACY, ROUTE_PRIVACY} from '../Routes'
import {useCookies} from 'react-cookie'

function CookieDialog({
                          showSettingsParam,
                          externalContentCookies,
                          handleClose,
                      }) {
    const {getT} = useTranslation()
    const [showSettings, setShowSettings] = useState(showSettingsParam)
    const [open, setOpen] = useState(false)
    const [cookies, setCookie] = useCookies()
    const [state, setState] = useState({
        checkedExternal: cookies.checkedExternal === true,
    })

    function shouldShowDialog() {
        return (!cookies.cookiesTechnical &&
                !cookies.checkedExternal) ||
            showSettingsParam
    }

    useEffect(function() {
        setOpen(shouldShowDialog())
        //save if banner was already opened in localStorgae - quickfix for cookies not working on iphone
        // @ts-ignore
        const bannerOpened = JSON.parse(window.localStorage.getItem('cookieBannerOpened')) || {
            opened: false,
        }
        if (bannerOpened.opened) {
            window.localStorage.setItem('cookieBannerOpened', JSON.stringify({opened: true}))
            setOpen(false)
        }
    }, [])

    const handleSave = (acceptAll) => {
        let expiryDate = new Date()
        expiryDate.setTime(expiryDate.getTime() + (365 * 24 * 60 * 60 * 1000))
        setCookie('cookiesTechnical', true, {path: '/', expires: expiryDate, sameSite: true, secure: true})
        if (externalContentCookies) {
            setCookie('checkedExternal', acceptAll || state.checkedExternal, {
                path: '/',
                expires: expiryDate,
                sameSite: true,
                secure: true,
            })
        }
        setOpen(false)
        setShowSettings(false)
        if (handleClose) {
            handleClose()
        }
    }

    const handleShowSettings = () => {
        setShowSettings(true)
    }

    const handleChange = name => event => {
        setState({...state, [name]: event.target.checked})
    }

    if (showSettings) {
        return (
            <>
                {open &&
                    <Dialog
                        open={showSettings}
                        /*
                        https://github.com/mui-org/material-ui/releases
                         */
                        disableEscapeKeyDown
                        aria-labelledby='form-dialog-title'>
                        <DialogTitle id='form-dialog-title'>{getT('cookie.settings.title')}</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                <FormControlLabel
                                    disabled
                                    control={<Switch checked color='secondary' value='checkedTechnical' />}
                                    label={getT('cookie.settings.technicalCookies')} />
                                <br />
                                {getT('cookie.settings.technicalText')}
                            </DialogContentText>
                            {externalContentCookies && <DialogContentText>
                                <FormControlLabel
                                    control={
                                        <Switch checked={state.checkedExternal}
                                                color='secondary'
                                                onChange={handleChange('checkedExternal')}
                                                value='checkedExternal' />
                                    }
                                    label={getT('cookie.settings.externalContentCookies')} />
                                <br />
                                {getT('cookie.settings.externalContentText')}
                            </DialogContentText>}
                            <DialogContentText>
                                <br />
                                <Link href={ROUTE_LANG_PRIVACY} as={ROUTE_PRIVACY}>

                                    {getT('cookie.infobutton')}

                                </Link>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => handleSave(false)} data-umami-event='cookies-accept-default'
                                    variant='contained' color='success'>
                                {getT('cookie.settings.savebutton')}
                            </Button>
                            <Button onClick={() => handleSave(true)}
                                    data-umami-event='cookies-accept-all'
                                    color='secondary'>
                                {getT('cookie.settings.acceptallbutton')}
                            </Button>
                        </DialogActions>
                    </Dialog>
                }
            </>
        );
    }

    return (
        <>
            {open &&
                <Dialog
                    open={open}
                    disableEscapeKeyDown
                    aria-labelledby='form-dialog-title'>
                    <DialogTitle id='form-dialog-title'>Cookies</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {getT('cookie.consentinfo')}
                            <Link href={ROUTE_LANG_PRIVACY} as={ROUTE_PRIVACY}>

                                {getT('cookie.infobutton')}

                            </Link>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleShowSettings} color='info'>
                            {getT('cookie.settingsbutton')}
                        </Button>
                        <Button onClick={() => handleSave(true)} color='success' variant='contained'>
                            {getT('cookie.acceptbutton')}
                        </Button>
                    </DialogActions>
                </Dialog>
            }
        </>
    );
}

export default CookieDialog
